'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeaturedContentCard = function (_React$Component) {
  _inherits(FeaturedContentCard, _React$Component);

  function FeaturedContentCard(props) {
    _classCallCheck(this, FeaturedContentCard);

    return _possibleConstructorReturn(this, (FeaturedContentCard.__proto__ || Object.getPrototypeOf(FeaturedContentCard)).call(this, props));
  }

  _createClass(FeaturedContentCard, [{
    key: 'getDisclosure',
    value: function getDisclosure() {
      var _props = this.props,
          disclosureText = _props.disclosureText,
          featuredCardContent = _props.featuredCardContent;

      var disclosure = "";

      if (!(0, _functional_utility.isNilOrEmpty)(disclosureText)) {
        disclosure = [disclosureText];
      } else if (!(0, _functional_utility.isNilOrEmpty)(featuredCardContent.disclosure)) {
        disclosure = [featuredCardContent.disclosure];
      }

      return disclosure;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          featuredCardContent = _props2.featuredCardContent,
          borderRequired = _props2.borderRequired;


      return _react2.default.createElement(
        'div',
        { className: (borderRequired === true ? "mango-left-border " : "") + "print-feature-content", 'data-testid': 'featured-content-card' },
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: featuredCardContent.title,
            headerTitleId: "fund-featured-card-title",
            placementId: "pdpCardKeyPoints",
            breakpoint: this.props.breakpoint,
            disclosureText: this.getDisclosure(),
            dataTest: 'fund-featured-content'
          },
          _react2.default.createElement(
            'div',
            { className: 'padding-all-5' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('div', { id: 'feature-card-description', 'data-testid': 'fund-featured-card-description',
                dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(featuredCardContent.description) } }),
              (0, _functional_utility.isDataEmpty)(featuredCardContent.image) ? "" : _react2.default.createElement(
                'div',
                { className: 'margin-top-25', 'data-testid': 'featured-card-image' },
                _react2.default.createElement('img', { id: 'featured-image',
                  alt: "",
                  className: "width-percent-100",
                  src: '' + featuredCardContent.image })
              )
            )
          )
        )
      );
    }
  }]);

  return FeaturedContentCard;
}(_react2.default.Component);

exports.default = FeaturedContentCard;